import { CustomField } from './../../../shared/_models/CustomField';

import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PosthogService } from 'on-shared/_services/posthog.service';
import { CustomFieldAiConfigModalComponent } from './custom-field-ai-config-modal/custom-field-ai-config-modal.component';

@Component({
    selector: 'on-custom-fields',
    templateUrl: './custom-fields.component.html',
    styleUrls: ['./custom-fields.component.scss'],
})
export class CustomFieldsComponent implements OnInit {
    @Input() customFields: CustomField[];
    @Input() userId: number;
    @Input() companyId: number;
    @Output() saveRequest = new EventEmitter();

    isAiRecognitionFeatureEnabled = false;

    constructor(
        private modalService: NgbModal,
        private posthogService: PosthogService,
    ) {}

    ngOnInit() {
        this.checkAiRecognitionFeatureFlag();
    }

    checkAiRecognitionFeatureFlag() {
        this.isAiRecognitionFeatureEnabled = this.posthogService.isFeatureEnabled(
            'custom-fields-ai-recognition',
        );
    }

    openAiConfigModal(field: CustomField) {
        const modalRef = this.modalService.open(CustomFieldAiConfigModalComponent);
        modalRef.componentInstance.customField = field;

        modalRef.result.then(
            (updatedField: CustomField) => {
                // Field updated by modal
            },
            (reason) => {
                // Modal dismissed
            },
        );
    }

    addCustomField() {
        this.customFields.push({
            Id: 0,
            Name: '',
            Description: '',
            ExpenseType: { Id: 1, Code: 'MISC', Name: '' },
            Type: 'string',
            UserId: this.companyId ? null : this.userId,
            CompanyId: this.companyId,
            IsRequired: false,
            PossibleValues: [],
        });
    }

    deleteCustomField(i) {
        this.customFields.splice(i, 1);
    }

    Save() {
        this.saveRequest.emit();
    }
}
